import { useCallback } from 'react';
import ModalWrapper from '../ModalWrapper';
import UIButton from 'UIComponents/button/UIButton';
import { track } from '../../../tracking/track';
import { events } from '../../../tracking/events';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import { useScopes } from 'growth-payments-core/auth/scopes';
import { INVOICES_WRITE, PAYMENT_LINKS_WRITE, QUOTE_CREATE, SUBSCRIPTIONS_WRITE } from '../../../constants/scopes';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import GoToProcessorPickerButtonWrapper from '../../GoToProcessorPickerButtonWrapper';
import { getCreateInvoicesURL, getCreateQuoteURL, getSubscriptionsURL } from 'growth-payments-core/urls/urls';
import { getCreatePaymentLink } from '../../../utils/channelUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CollectPaymentsWithHubSpotModal = ({
  onClose,
  page,
  location,
  ButtonPrimary = GoToProcessorPickerButtonWrapper
}) => {
  const scopes = useScopes();
  const hasPaymentLinksWrite = scopes.has(PAYMENT_LINKS_WRITE);
  const hasInvoicesWrite = scopes.has(INVOICES_WRITE);
  const hasQuoteCreate = scopes.has(QUOTE_CREATE);
  const hasSubscriptionsWrite = scopes.has(SUBSCRIPTIONS_WRITE);
  const Body = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.collectPaymentsWithHubSpotModal.p1"
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      styled: true,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.collectPaymentsWithHubSpotModal.bullet1"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.collectPaymentsWithHubSpotModal.bullet2"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.collectPaymentsWithHubSpotModal.bullet3"
      })]
    })]
  });
  const handleClick = useCallback(value => () => {
    track(events.paymentsInterstitialModalInteraction, {
      action: 'click',
      screen: page,
      subscreen: location,
      value
    });
  }, [page, location]);
  const Footer = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ButtonPrimary, {
      sourceApp: page,
      location: location,
      use: "primary"
    }), /*#__PURE__*/_jsx(UIDropdown, {
      buttonSize: "medium",
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.collectPaymentsWithHubSpotModal.tryPaymentTool"
      }),
      placement: "bottom",
      buttonUse: "secondary",
      onOpenComplete: handleClick('tryPaymentTool'),
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [/*#__PURE__*/_jsx(UITooltip, {
          placement: "right",
          disabled: hasInvoicesWrite,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "embedPoints.tooltips.missingPermissions"
          }),
          children: /*#__PURE__*/_jsx(UIButton, {
            disabled: !hasInvoicesWrite,
            onClick: handleClick('createInvoice'),
            external: true,
            href: getCreateInvoicesURL(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "embedPoints.ctas.createInvoice"
            })
          })
        }), /*#__PURE__*/_jsx(UITooltip, {
          placement: "right",
          disabled: hasSubscriptionsWrite,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "embedPoints.tooltips.missingPermissions"
          }),
          children: /*#__PURE__*/_jsx(UIButton, {
            disabled: !hasSubscriptionsWrite,
            onClick: handleClick('createSubscription'),
            external: true,
            href: getSubscriptionsURL(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "embedPoints.ctas.createSubscription"
            })
          })
        }), /*#__PURE__*/_jsx(UITooltip, {
          placement: "right",
          disabled: hasPaymentLinksWrite,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "embedPoints.tooltips.missingPermissions"
          }),
          children: /*#__PURE__*/_jsx(UIButton, {
            disabled: !hasPaymentLinksWrite,
            onClick: handleClick('createPaymentLink'),
            external: true,
            href: getCreatePaymentLink(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "embedPoints.ctas.createPaymentLink"
            })
          })
        }), /*#__PURE__*/_jsx(UITooltip, {
          placement: "right",
          disabled: hasQuoteCreate,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "embedPoints.tooltips.missingPermissions"
          }),
          children: /*#__PURE__*/_jsx(UIButton, {
            disabled: !hasQuoteCreate,
            onClick: handleClick('createQuote'),
            external: true,
            href: getCreateQuoteURL(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "embedPoints.ctas.createQuote"
            })
          })
        })]
      })
    })]
  });
  return /*#__PURE__*/_jsx(ModalWrapper, {
    onClose: onClose,
    modalName: "collectPaymentsWithHubSpotModal",
    Body: Body,
    Footer: Footer,
    illustrationName: "payments"
  });
};
export default CollectPaymentsWithHubSpotModal;